import { loadMore } from "../utils/loadMore";

function wineAcademySubRegionLoadMore () {
  const producers = document.querySelector('.js-wine-academy-sub-region .js-load-more-list')
  if (producers) loadMore(producers);
}

wineAcademySubRegionLoadMore()
